import cn from 'classnames';
import { DashboardMenu } from "../components/DashboardMenu";
import React, { useEffect, useState } from 'react';
import { ModalProvider, useModal } from '../context/ModalContext';
import { CreateRoomModal } from '../components/CreateRoomModal';

const SecurityLayoutContent = ({ children }: { children: React.ReactNode }) => {
  const [showMenu, setShowMenu] = useState(true);
  const [mapReload, setMapReload] = useState(false);
  const { showCreateRoomModal, setShowCreateRoomModal, createRoomModalProps } = useModal();

  useEffect(() => {
    setMapReload(true);

    setTimeout(() => {
      setMapReload(false);
    })
  }, [showMenu]);

  const childrenWithProps = React.Children.map(children, child => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { showMenu, setShowMenu, mapReload } as Partial<unknown>);
    }
    return child;
  });

  return (
    <>
      <div className={cn("flex flex-row min-h-screen relative", {})}>
        {showMenu && <DashboardMenu />}
        <div className='flex-1 relative bg-[#F7F8FA]'>
          {childrenWithProps}
        </div>
      </div>
      
      {/* Global Modals */}
      {showCreateRoomModal && (
        <CreateRoomModal
          onClose={() => setShowCreateRoomModal(false)}
          projectId={createRoomModalProps.projectId}
          siteId={createRoomModalProps.siteId}
        />
      )}
    </>
  );
};

export const SecurityLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <ModalProvider>
      <SecurityLayoutContent>
        {children}
      </SecurityLayoutContent>
    </ModalProvider>
  );
};
